(ns superadmin.os-workspace-editor.db
  (:require [common.url-template :as url-tpl]
            [re-frame.core :as rf]))

(rf/reg-event-fx :os-workspace-editor/delete-mapping
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context :resource.user/token]} [_ {:keys [workspace-id]}]]
    {:fx [[:http
           {:method :delete
            :headers {"Authorization" token}
            :uri (str (url-tpl/render :api/os-workspace-mapping url-context) "/" workspace-id)
            :on-success [::delete-mapping-success]}]]}))

(rf/reg-event-fx ::delete-mapping-success
  (fn []
    {:fx [[:invalidate-queries {:queryKey ["workspace-mappings"]}]]}))
